import React from 'react';
import PropTypes from 'prop-types';
import animateScrollTo from 'animated-scroll-to';
import exact from 'prop-types-exact';
import Button from '../../../common/button/Button';

const SearchButton = (props) => {
    function _handleSearch(event) {
        event.preventDefault();

        document.body.style.overflow = 'hidden';

        if (props.currentPath.indexOf('/busca') !== -1) {
            // highlight the form that is already on the page
            // note: this is not a good "react" way of doing it, but it seams to be ok in this case. (not in mood to wire this to redux)
            const searchFormInput = document.getElementsByClassName('search-input-form-input')[1]; // there are more than one...

            if (searchFormInput) {
                searchFormInput?.focus();

                searchFormInput.style.transition = 'none';

                searchFormInput.style['border-color'] = '#437bff';

                setTimeout(() => {
                    searchFormInput.style.transition = 'border 0.5s ease-in-out'; // this should maybe be reset back to the initial value (none at the moment)?!

                    searchFormInput.style['border-color'] = '#ced4da';
                }, 500, searchFormInput);
            }


            animateScrollTo(0, { speed: 700 });
        } else {
            // show the search box
            props.setModalSearchBoxState(true);
        }
    }

    return (

        <Button className="tw-flex" onClick={(e) => _handleSearch(e)} title="Pesquisar">
            <svg width="19" height="19" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.19173 13.2614C8.59692 13.2611 9.96167 12.7907 11.0686 11.925L14.5487 15.4052L15.6681 14.2858L12.188 10.8056C13.0541 9.69863 13.5248 8.33361 13.5251 6.92806C13.5251 3.43602 10.6838 0.594727 7.19173 0.594727C3.69969 0.594727 0.858398 3.43602 0.858398 6.92806C0.858398 10.4201 3.69969 13.2614 7.19173 13.2614ZM7.19173 2.17806C9.81137 2.17806 11.9418 4.30843 11.9418 6.92806C11.9418 9.54773 9.81137 11.678 7.19173 11.678C4.57211 11.678 2.44173 9.54773 2.44173 6.92806C2.44173 4.30843 4.57211 2.17806 7.19173 2.17806Z" fill="#1E2024" />
            </svg>
            <span>Pesquisar</span>
        </Button>

    );
};

SearchButton.propTypes = exact({
    setModalSearchBoxState: PropTypes.func,
    currentPath: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string,
    ]),
});

export default SearchButton;
